module.exports = __webpack_public_path__ + "img/二级页面海报低功耗室内机.302b3b13.jpg";